import React from "react";
import { Link } from "react-router-dom";

const LocationTerms = () => {
  const content = `개인위치정보사업 및 위치기반서비스 이용약관)

제1조(목적) 본 약관은 주식회사 마이즈(이하 “회사”라고 합니다)의 개인위치정보사업 및 위치기반서비스 약관에 동의한 개인위치정보주체(이하 “회원”이라고 합니다)의 개인위치정보를 수집하고, 위치정보사업자 및 위치기반서비스사업자의 지위에서 「위치정보의 보호 및 이용 등에 관한 법률」(이하 “위치정보법”이라 합니다)의 규정에 따라 회사가 제공하는 스마트통합관리시스템 위치기반서비스(이하 “서비스”라고 합니다)를 이용함에 회사와 회원의 권리·의무 및 기타 필요한 사항을 규정함을 목적으로 합니다.

제2조(이용약관의 효력 및 변경) ① 본 약관은 개인위치정보사업의 고객 또는 개인위치정보주체가 본 약관에 동의하고 회사 소정의 절차에 따라 위치정보사업 및 서비스의 이용자로 등록함으로써 효력이 발생합니다.
  ② 회원이 온라인에서 본 약관의 "동의하기" 버튼을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에 동의한 것으로 봅니다.
  ③ 회사는 위치정보사업 및 서비스의 변경사항을 반영하기 위하여 필요한 경우 등에는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법, 약관의 규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.
  ④ 회사가 약관을 개정할 경우에는 적용일자, 개정사유, 현행약관 및 개정약관의 내용과 개정약관 적용일까지 동의 또는 거부의 의사표시를 하지 아니하면 개정약관에 동의한 것으로 본다는 내용을 각 명시하여 다음과 같은 방법으로 게시 및 통지합니다.
   1. 위치정보사업자 및 서비스 홈페이지 등 게시 : 개정약관 적용일 30일 전부터 적용일 이후 상당한 기간(15일간)
   2. 회원에게 전자적 형태(전자우편, SMS 등)로 개별 통지 : 개정약관 적용일로부터 30일 전
  ⑤ 회사의 전항에 따른 게시 및 통지 후에도 회원이 개정약관 적용일까지 개정약관에 대해 동의 또는 거부의 의사표시를 하지 않을 때에는 회원이 해당 개정약관에 동의한 것으로 봅니다.
  ⑥ 회원이 개정약관에 동의하지 않을 경우 (회사 또는) 회원은 이용계약을 해지할 수 있습니다.

제3조(관계법령의 적용)  본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령 또는 상관례에 따릅니다.

제 4조(개인위치정보 수집방법 및 서비스의 이용 등) ①  회사가 제공하는 위치기반서비스 및 개인위치정보 및 개인위치정보의 수집방법, 보유목적과 보유기간은 아래와 같습니다.

서비스 명
수집방법
서비스 내용 및 
(보유)목적
개인위치정보
 보유기간
건설현장 스마트 통합 관리 시스템
비콘 통신단말기
및 GPS
현장 안전 강화
위험지역 접근경고
작업장 내 위치정보주체의 위치 확인
 사고 대응 시간 단축
6개월


  ② 회사는 「위치정보의 보호 및 이용 등에 관한 법률」 제16조제2항에 따라 위치정보 수집·이용·제공사실 확인자료를 자동 기록·보존하며, 해당 자료는 6개월간 보관합니다.
  ③ 회사는 개인위치정보의 수집·이용 또는 제공목적을 달성한 때에는 제2항의 위치정보 수집·이용·제공사실 확인자료를 제외한 개인위치정보를 즉시 파기합니다. 다만, 다른 법률에 따라 보유하여야 하거나 회원이 개인위치정보의 보유에 별도로 동의한 경우에는 회원이 동의한 때로부터 최대 1년간 이를 보유할 수 있습니다.

제5조(서비스 이용요금 및 조건) 
  ① 서비스 이용요금 : 무료
  ② 서비스 이용을 위한 데이터 통신 비용 : 이동통신사 및 회원의 가입 요즘제에 따름.

제6조(서비스 추가·변경) 회사가 서비스의 추가·변경이 필요한 경우, 제4조에 그 내용을 반영하여 제2조 제4항 내지 제5항에 따라 게시 및 통지하여야 합니다.

제7조(수집·이용·제공의 제한 및 중지) ① 회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우 수집·제공 및 서비스의 일부 혹은 전부의 이용을 제한하거나 중지할 수 있습니다.

  1. 개인위치정보주체가 회사에 대하여 개인위치정보의 수집, 이용 및 제공에 대한 동의를 전부 또는 일부 철회하는 경우
  2. 개인위치정보주체가 회사에 대하여 개인위치정보의 수집, 이용 및 제공의 일시적인 중지를 요청하는 경우

  ② 회사는 전항의 규정에 의하여 개인위치정보 수집·제공 및 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 위치정보사업자의 홈페이지 등에 게시하고 전자적 형태(전자우편, SMS 등)로 개별 통지하여야 합니다.
 ③ 회사가 전항에 따른 게시 및 통지를 할 수 없는 부득이한 사유가 있는 경우 사후에 게시 및 통지할 수 있습니다.

제8조(개인위치정보의 수집) ① 회사는 개인위치정보를 수집하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.
  ② 회원이 개인위치정보의 수집에 동의를 하는 경우, 개인위치정보 수집의 범위 및 이용약관의 내용 중 일부에 대하여 동의를 유보할 수 있습니다.
  ③회사가 개인위치정보를 수집하는 경우에는 수집목적을 달성하기 위하여 필요한 최소한의 정보만을 수집합니다.

제9조(개인위치정보의 이용 또는 제공) ① 회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.
  ② 회사는 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 제공받는 자 및 제공목적을 사전에 회원에게 고지하고 동의를 받습니다.
  ③ 제2항에 따라 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 해당 통신 단말장치 또는 전자우편주소 등으로 매회 회원에게 제공받는 자, 제공일시 및 제공목적(이하 “정보제공내역”이라 합니다)을 즉시 통보합니다. 
  ④ 단, 아래 각 호에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신단말장치 또는 전자우편주소 등으로 통보합니다.
   1. 개인위치정보를 수집한 해당 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우
   2. 회원이 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우
  ⑤ 제3항에도 불구하고 회원은 위치정보법 시행령 제24조에 따라 정보제공내역을 90일간 모아서 통보받는 방법을 선택할 수 있으며, 회원이 회사의 절차에 따라 요청할 경우 전항에 따른 즉시 통보 방법으로 변경할 수 있습니다.
  ⑥ 회원은 제1항·제2항·제5항에 따른 동의를 하는 경우 이용·제공목적, 제공받는 자의 범위 및 위치기반서비스 이용약관의 내용 중 일부와 회원의 개인위치정보에 대한 제3자 제공의 경우 통보방법에 대하여 동의를 유보할 수 있습니다.

제10조 (개인위치정보의 수집·이용 또는 제공의 제한) 회사는 회원의 동의가 있거나 다음 각 호의 어느 하나에 해당하는 경우를 제외하고는 개인위치정보 또는 위치정보 수집·이용·제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나 제3자에게 제공할 수 없습니다.
       1. 위치기반서비스 요금정산을 위하여 위치정보 수집·이용·제공사실 확인자료가 필요한 경우
      2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우

제11조(개인위치정보주체의 권리 및 행사방법) ① 회원은 회사에 대하여 언제든지 개인위치정보 수집·이용·제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다. 이 경우 회사는 수집·이용·제공한 개인위치정보 및 위치정보 수집·이용·제공사실 확인자료를 파기합니다. 단, 동의의 일부를 철회하는 경우에는 철회하는 부분의 개인위치정보 및 위치정보 수집·이용·제공사실 확인자료에 한합니다.
  ② 회원은 회사에 대하여 언제든지 개인위치정보 수집·이용 또는 제공의 일시적인 중지를 요구할 수 있고, 회사는 이를 거절할 수 없으며 이를 위한 기술적 수단을 갖추고 있습니다.
  ③ 회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 해당 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.
   1. 본인에 대한 위치정보 수집·이용·제공사실 확인자료
   2. 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용
  ④ 회원은 제1항 내지 제3항의 권리행사를 위해 (고객센터 등 구체적 절차 기술)를 통해 요구할 수 있습니다.

제12조(법정대리인의 권리 및 행사방법) ① 회사는 14세 미만의 회원의 경우, 개인위치정보 수집·이용·제공에 대하여 해당 회원과 그 법정대리인 모두의 동의를 받아야 합니다. 이 경우 법정대리인은 제11조에 의한 회원의 권리를 모두 가집니다.
  ② 회사는 다음 각 호의 어느 하나에 해당하는 방법으로 법정대리인이 동의했는지를 확인합니다.
   1. 동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 위치정보사업자등이 그 동의 표시를 확인했음을 법정대리인의 휴대전화 문자메시지로 알리는 방법
   2. 동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리인의 신용카드ㆍ직불카드 등의 카드정보를 제공받는 방법
   3. 동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리인의 휴대전화 본인인증 등을 통해 본인 여부를 확인하는 방법
   4. 동의 내용이 적힌 서면을 법정대리인에게 직접 발급하거나, 우편 또는 팩스를 통하여 전달하고 법정대리인이 동의 내용에 대하여 서명날인 후 제출하도록 하는 방법
   5. 동의 내용이 적힌 전자우편을 발송하여 법정대리인으로부터 동의의 의사표시가 적힌 전자우편을 전송받는 방법
   6. 전화를 통하여 동의 내용을 법정대리인에게 알리고 동의를 얻거나 인터넷주소 등 동의 내용을 확인할 수 있는 방법을 안내하고 재차 전화 통화를 통하여 동의를 얻는 방법
   7. 그 밖에 제1호부터 제6호까지의 규정에 따른 방법에 준하는 방법으로 법정대리인에게 동의 내용을 알리고 동의의 의사표시를 확인하는 방법

제13조(8세 이하의 아동 등의 보호의무자의 권리･의무 및 행사방법) ① 회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 수집·이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.
   1. 8세 이하의 아동
   2. 피성년후견인
   3. 「장애인복지법」제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서「장애인고용촉진 및 직업재활법」 제2조제2호의 규정에 의한 중증장애인에 해당하는 자(「장애인복지법」 제32조의 규정에 의하여 장애인등록을 한 자에 한한다)
  ② 제1항에 따른 8세 이하의 아동등의 보호의무자는 8세 이하의 아동등을 사실상 보호하는 자로서 다음 각 호의 어느 하나에 해당하는 자를 말합니다.
   1. 8세 이하의 아동의 법정대리인 또는 「보호시설에 있는 미성년자의 후견 직무에 관한 법률」 제3조에 따른 후견인
   2. 피성년후견인의 법정대리인
   3. 제1항제3호의 자의 법정대리인 또는 「장애인복지법」 제58조제1항제1호에 따른 장애인 거주시설(국가 또는 지방자치단체가 설치ㆍ운영하는 시설로 한정한다)의 장, 「정신건강증진 및 정신질환자 복지서비스 지원에 관한 법률」 제22조에 따른 정신요양시설의 장 및 같은 법 제26조에 따른 정신재활시설(국가 또는 지방자치단체가 설치ㆍ운영하는 시설로 한정한다)의 장
  ③ 제1항에 따른 동의를 하고자 하는 8세 이하 아동 등의 보호의무자는 각 호의 사항을 기재하여 기명날인 또는 서명한 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.
   1. 8세 이하의 아동등의 성명, 주소 및 생년월일
   2. 보호의무자의 성명, 주소 및 연락처
   3. 개인위치정보 수집·이용 또는 제공의 목적이 8세 이하의 아동등의 생명 또는 신체의 보호에 한정된다는 사실
   4. 동의의 연월일
  ④ 보호의무자는 8세 이하의 아동 등의 개인위치정보 수집·이용 또는 제공에 동의하는 경우 제11조에 의한 회원의 권리 전부를 행사할 수 있습니다.

제14조(위치정보관리책임자의 지정) 회사는 개인위치정보를 적절히 관리·보호하고, 개인위치정보주체의 불만을 원활히 처리하기 위하여 위치정보관리책임자를 지정하여 운영합니다. 위치정보관리책임자의 성명 및 연락처 등 구체적인 사항은 회사의 개인위치정보 처리방침에 따릅니다.

제15조(손해배상) ① 회원은 회사가 「위치정보의 보호 및 이용 등에 관한 법률」 등 관계 법령 또는 본 약관의 규정을 위반하여 회원에게 손해를 발생하게 한 경우 회사에 대하여 손해배상을 청구할 수 있습니다.
  ② 제1항의 경우 회사는 고의 또는 과실이 없음을 입증하지 못하는 한 책임을 면할 수 없습니다.
  ③ 회사는 회원의 손해가 회사의 고의 또는 과실에 의하지 아니하고, 회원의 고의 또는 과실 등 회사의 책임 없는 사유로 발생한 경우에는 책임을 지지 않습니다.


제16조(면책) ① 회사는 다음 각 호의 어느 하나에 해당하는 사유로 인하여 서비스를 제공할 수 없는 경우에는 그로 인하여 발생한 손해에 대하여 책임을 지지 않습니다.
   1. 천재지변, 전쟁, 폭동, 테러, 감염병 확산, 국가비상사태 기타 이에 준하는 불가항력의 사유가 있는 경우
   2. 기간통신사업자, 이동통신사업자, 위치정보 수집·제공 설비 보유자 또는 제휴사의 서비스 장애, 설비 보수, 교체, 점검, 공사 등 부득이한 사유가 있는 경우
   3. GPS 오차, 전파 음영지역, 단말기 성능, 운영체제 또는 네트워크 환경 등으로 위치정보가 정확하게 수집·전송되지 아니한 경우
   4. 회원의 귀책사유로 서비스 이용에 장애가 발생한 경우
  ② 회사는 회원이 서비스에 게시 또는 전송한 정보, 자료, 사실의 신뢰도, 정확성 또는 완전성에 대하여 보증하지 않으며, 이로 인하여 발생한 손해에 대하여 책임을 지지 않습니다.
  ③ 회사는 회원 상호 간 또는 회원과 제3자 사이에서 서비스를 매개로 하여 발생한 분쟁에 개입할 의무가 없으며, 회사의 고의 또는 과실이 없는 한 이로 인한 손해를 배상할 책임을 지지 않습니다.
  ④ 회사는 무료로 제공되는 서비스와 관련하여 관계 법령에 특별한 규정이 없는 한 책임을 지지 않습니다. 다만, 회사의 고의 또는 중대한 과실이 있는 경우에는 그러하지 않습니다.

제17조(준거법 및 재판관할) ① 본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.
  ② 회원 및 법정대리인의 권리와 그 행사방법은 제소 당시의 이용자의 주소에 의하며, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다.

제18조(분쟁의 조정 및 기타) ① 회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 「위치정보의 보호 및 이용 등에 관한 법률」 제28조의 규정에 의해 방송통신위원회에 재정을 신청할 수 있습니다.
  ② 회사 또는 회원은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 「개인정보보호법」 제43조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다

제19조(회사의 연락처) 회사의 상호 및 주소 등은 다음과 같습니다.
  1. 상    호 : 주식회사 마이즈
  2. 대 표 자 : 강지영, 김영훈
  3. 주    소 : 인천광역시 연수구 컨밴시아대로165, 포스코타워-송도 27층
  4. 대표전화 : 1670-6640


부  칙

제1조(시행일) 이 약관은 2025년 07월 01일부터 시행한다.
`;

  return (
    <div className="terms_page">
      <div className="terms_box">
        <h1 className="terms_title">위치정보 이용약관</h1>

        <div className="terms_content">{content}</div>
      </div>
    </div>
  );
};

export default LocationTerms;
